module.exports = __webpack_public_path__ + "img/awaken-comp-bg.cf8394b.jpg";